import { defaultReducer } from 'app/store/defaultReducer';
import { createReducerTool, createStateTool } from 'app/store/withDevTools';
import { HistoricoRemessaTypes } from './historicoRemessaAction';

export const initState = createStateTool({
  page: { content: [] },
  requestParams: {
    page: 1,
    size: 15,
    q: undefined,
    sort: 'sequencial,desc',
    totalCount: undefined,
  },
  selecionados: [],
  message: undefined,
  carregandoRegistros: false,
});

function reducer(state, action, types) {
  return defaultReducer(state, action, types);
}

export const historicoRemessaState = createReducerTool(reducer, HistoricoRemessaTypes);
